"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordSetRepository = void 0;
var RecordRepository_1 = require("./RecordRepository");
var RecordSetRepository = /** @class */ (function () {
    function RecordSetRepository() {
        this.store = {};
    }
    RecordSetRepository.prototype.add = function (name) {
        return this.get(name) || (this.store[name] = new RecordRepository_1.RecordRepository(name));
    };
    RecordSetRepository.prototype.get = function (name) {
        var _a;
        return (_a = this.store[name]) !== null && _a !== void 0 ? _a : null;
    };
    RecordSetRepository.prototype.getAll = function () {
        return Object.values(this.store);
    };
    return RecordSetRepository;
}());
exports.RecordSetRepository = RecordSetRepository;
